"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSTAL_CODE_PATTERN = void 0;
exports.validateAddress = validateAddress;
const mexican_states_1 = require("../constants/mexican-states");
/**
 * Validates address fields
 *
 * @param props - Address properties to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateAddress(props) {
    if (!props.street?.trim()) {
        return { isValid: false, error: 'Calle es requerida' };
    }
    if (!props.exteriorNumber?.trim()) {
        return { isValid: false, error: 'Número exterior es requerido' };
    }
    if (!props.neighborhood?.trim()) {
        return { isValid: false, error: 'Colonia es requerida' };
    }
    if (!props.city?.trim()) {
        return { isValid: false, error: 'Ciudad es requerida' };
    }
    if (!props.zipCode?.trim()) {
        return { isValid: false, error: 'Código postal es requerido' };
    }
    if (!/^\d{5}$/.test(props.zipCode.trim())) {
        return { isValid: false, error: 'Código postal inválido. Debe tener 5 dígitos' };
    }
    if (!props.state) {
        return { isValid: false, error: 'Estado es requerido' };
    }
    // Check if state is valid
    if (!(props.state in mexican_states_1.MEXICAN_STATES)) {
        return { isValid: false, error: 'Código de estado inválido' };
    }
    if (!props.country?.trim()) {
        return { isValid: false, error: 'País es requerido' };
    }
    const normalizedCountry = props.country.toLowerCase().trim();
    if (normalizedCountry !== 'méxico' && normalizedCountry !== 'mexico') {
        return { isValid: false, error: 'Solo se soporta México como país' };
    }
    return { isValid: true };
}
/**
 * Regex pattern for postal code validation (5 digits)
 * Can be used directly in form libraries that accept regex
 */
exports.POSTAL_CODE_PATTERN = /^\d{5}$/;
